import { EventLocationFormData } from '~admin/view/components/details/event-details/event-location-details';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';

/**
 * Transforms EventLocationFormData to Partial<EventProfileCreateRequest>
 * @param values
 */
export const getEventLocationDetailsRequest = (
  values: EventLocationFormData,
): Pick<
  EventProfileCreateRequest,
  'eventLocationId' | 'seatConfigurationId' | 'eventAccessibilityType' | 'seatMapMediaId'
> => {
  const { eventLocationId, seatConfigurationId, eventAccessibilityType, seatMapMedia } = values;

  return {
    eventLocationId,
    seatConfigurationId,
    eventAccessibilityType,
    seatMapMediaId: seatMapMedia?.id,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request/event-location-details-request.helper.ts